<template>
	<div class="warehouse-goods">
		<div class="btnbox">
			<el-button size="small" @click="goBuyout">我的报价</el-button>
		</div>
		<div class="empty-guide" v-if="ready && !warehouseId">
			<div class="empty-title">请先开通云仓</div>
			<div class="empty-desc">开通并通过审核后才能管理仓内商品售价。</div>
			<el-button type="primary" @click="goIndex">返回云仓首页</el-button>
		</div>
		<div class="tablebox" v-if="ready && warehouseId">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" size="small" label-width="0">
					<el-form-item>
						<el-input v-model="formfilter.style_number" placeholder="款号" clearable
							@keyup.enter.native="onfilter"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
					<el-form-item>
						<el-button size="small" @click="openOwnImport">导入自有库存</el-button>
						<el-button size="small" @click="openOwnAdd">手动加库存</el-button>
						<el-button type="warning" :disabled="!selected.length" @click="openCostDiscount">设置成本折扣{{
							selected.length ? '（已选 ' + selected.length + '）' : '' }}</el-button>
						<el-button type="warning" :disabled="!selected.length" @click="openMarkup">批量设置加价{{
							selected.length ? '（已选 ' + selected.length + '）' : '' }}</el-button>
						<el-button type="primary" :disabled="!selected.length" @click="openOffer">发起变现报价{{
							selected.length ? '（已选 ' + selected.length + '）' : '' }}</el-button>
					</el-form-item>
					<el-form-item>
						<span class="def-markup">默认加价：<b>{{ formatMarkupDiscount(defaultMarkup) }}</b></span>
						<el-button size="small" type="text" @click="openDefaultMarkup">修改</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%" v-loading="loading"
					@selection-change="onSelect">
					<el-table-column type="selection" width="46" align="center"></el-table-column>
					<el-table-column label="来源" align="center" header-align="center" width="140px">
						<template slot-scope="scope">
							<span :class="canOffer(scope.row) ? 'ok-text' : 'gray-text'">{{ sourceText(scope.row) }}</span>
							<el-tag v-if="canOffer(scope.row)" size="mini" type="success">可报价</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="style_number" label="款号" align="center" header-align="center"
						min-width="120px"></el-table-column>
					<el-table-column prop="size" label="尺码" align="center" header-align="center" width="70px"></el-table-column>
					<el-table-column label="可用量" align="center" header-align="center" width="80px">
						<template slot-scope="scope">{{ available(scope.row) }}</template>
					</el-table-column>
					<el-table-column label="吊牌价" align="center" header-align="center" width="100px">
						<template slot-scope="scope">¥{{ fenToYuan(scope.row.retail_price) }}</template>
					</el-table-column>
					<el-table-column label="综合拿货折扣" align="center" header-align="center" width="150px">
						<template slot-scope="scope">
							<template v-if="isOwned(scope.row)">
								<span>{{ ownedDiscountText(scope.row) }}</span>
								<el-tag v-if="ownedDiscountText(scope.row) !== '—'" size="mini" type="warning">自有货</el-tag>
							</template>
							<template v-else>{{ formatCompositeDiscount(scope.row.composite_discount) }}</template>
						</template>
					</el-table-column>
					<el-table-column label="加价折扣" align="center" header-align="center" width="150px">
						<template slot-scope="scope">
							<span>{{ formatMarkupDiscount(Number(scope.row.markup_discount || 0) / 100) }}</span>
							<el-tag v-if="Number(scope.row.markup_discount_custom || 0) > 0" size="mini"
								type="warning">单独</el-tag>
							<el-tag v-else size="mini">跟随</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="建议售价" align="center" header-align="center" width="110px">
						<template slot-scope="scope">¥{{ fenToYuan(scope.row.suggest_price) }}</template>
					</el-table-column>
					<el-table-column prop="update_time_str" label="更新时间" align="center" header-align="center"
						width="160px"></el-table-column>
				</el-table>
			</div>
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>

		<el-dialog title="批量设置加价折扣" :visible.sync="markupShow" width="440px" :before-close="closeMarkup">
			<div class="forms" v-if="markupShow">
				<el-form label-width="90px">
					<el-form-item label="已选商品">
						<div>{{ selected.length }} 个</div>
					</el-form-item>
					<el-form-item label="加价折扣">
						<el-input v-model="markupValue" placeholder="0~10，如 2 表示加 2 折">
							<template slot="append">折</template>
						</el-input>
					</el-form-item>
					<div class="tip">0 = 恢复跟随云仓默认；大于 0 = 单独覆盖；单次最多 500 个。</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeMarkup">取消</el-button>
				<el-button type="primary" :loading="markupSaving" @click="onSaveMarkup">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="修改默认加价折扣" :visible.sync="defaultMarkupShow" width="460px" :before-close="closeDefaultMarkup">
			<div class="forms" v-if="defaultMarkupShow">
				<el-form label-width="110px">
					<el-form-item label="加价折扣">
						<el-input v-model="defaultMarkupValue" placeholder="0~10，如 2 表示加 2 折">
							<template slot="append">折</template>
						</el-input>
					</el-form-item>
					<div class="tip">售价 = 吊牌价 × (成本折扣 + 加价折扣) ÷ 10；自有货按成本折扣计算。0 = 不加价；仅对「跟随」商品生效，「单独」设置的商品不受影响。</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeDefaultMarkup">取消</el-button>
				<el-button type="primary" :loading="defaultMarkupSaving" @click="onSaveDefaultMarkup">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="导入自有库存" :visible.sync="ownImportShow" width="600px" :before-close="closeOwnImport">
			<div class="uploaddiv" v-if="ownImportShow">
				<div class="i_b">
					<el-input v-model="ownImportText" placeholder="请上传文件" size="small" :readonly="true"></el-input>
					<myupload @resultUrl="onOwnImportUrl" :uptype="2"></myupload>
				</div>
				<div class="a" @click="ondownload">下载模版</div>
			</div>
			<div class="tip" style="margin-top: 12px;">模板 4 列：款号、尺码、数量、成本折扣（如 4.35）。导入为异步任务，完成后请到任务中心-导入列表查看结果。</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeOwnImport">取消</el-button>
				<el-button type="primary" :loading="ownImportSaving" @click="onSaveOwnImport">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="手动加库存" :visible.sync="ownAddShow" width="460px" :before-close="closeOwnAdd">
			<div class="forms" v-if="ownAddShow">
				<el-form label-width="90px">
					<el-form-item label="款号" required>
						<el-input v-model="ownAddForm.style_number" placeholder="须存在于商品库" maxlength="64"></el-input>
					</el-form-item>
					<el-form-item label="尺码" required>
						<el-input v-model="ownAddForm.size" placeholder="如 M（自动转大写）" maxlength="32"></el-input>
					</el-form-item>
					<el-form-item label="数量" required>
						<el-input v-model="ownAddForm.quantity" placeholder="1-100000 的正整数"></el-input>
					</el-form-item>
					<el-form-item label="成本折扣" required>
						<el-input v-model="ownAddForm.cost_discount" placeholder="0~10，如 4.35 表示 4.35 折">
							<template slot="append">折</template>
						</el-input>
					</el-form-item>
					<div class="tip">同款 + 同尺码 + 同成本折扣会累加到已有自有库存行；仅定价参考，不影响保证金 / 平台费。</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeOwnAdd">取消</el-button>
				<el-button type="primary" :loading="ownAddSaving" @click="onSaveOwnAdd">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="设置成本折扣" :visible.sync="costDiscountShow" width="460px" :before-close="closeCostDiscount">
			<div class="forms" v-if="costDiscountShow">
				<el-form label-width="90px">
					<el-form-item label="已选商品">
						<div>{{ selected.length }} 个</div>
					</el-form-item>
					<el-form-item label="成本折扣">
						<el-input v-model="costDiscountValue" placeholder="0~10，如 4.35 表示 4.35 折">
							<template slot="append">折</template>
						</el-input>
					</el-form-item>
					<div class="tip">售价 = 吊牌价 ×（成本折扣 + 加价折扣）÷ 10；仅对自有货生效；单次最多 500 个。</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeCostDiscount">取消</el-button>
				<el-button type="primary" :loading="costDiscountSaving" @click="onSaveCostDiscount">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="发起变现报价" :visible.sync="offerShow" width="880px" :before-close="closeOffer">
			<div class="forms" v-if="offerShow">
				<el-table :data="offerItems" border size="mini" style="width: 100%" max-height="280">
					<el-table-column prop="style_number" label="款号" min-width="110"></el-table-column>
					<el-table-column prop="size" label="尺码" width="60" align="center"></el-table-column>
					<el-table-column label="吊牌价" width="90" align="center">
						<template slot-scope="scope">¥{{ fenToYuan(scope.row.retail_price) }}</template>
					</el-table-column>
					<el-table-column label="综合拿货折扣" width="110" align="center">
						<template slot-scope="scope">{{ formatCompositeDiscount(scope.row.composite_discount) }}</template>
					</el-table-column>
					<el-table-column label="可报" width="60" align="center">
						<template slot-scope="scope">{{ scope.row.available }}</template>
					</el-table-column>
					<el-table-column label="数量" width="110" align="center">
						<template slot-scope="scope">
							<el-input-number v-model="scope.row.quantity" :min="1" :max="scope.row.available"
								:precision="0" :controls="false" size="mini"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column label="扣减单价预估" width="110" align="center">
						<template slot-scope="scope">{{ estStr(estQuote(scope.row)) }}</template>
					</el-table-column>
				</el-table>
				<el-form label-width="110px" class="offer-form">
					<el-form-item label="变现折扣">
						<el-input v-model="offerForm.discount" placeholder="折数形态，如 4.5 表示 4.5 折（0.1 折步进）">
							<template slot="append">折</template>
						</el-input>
					</el-form-item>
					<el-form-item label="备注">
						<el-input v-model="offerForm.remark" placeholder="选填，不超过255字"></el-input>
					</el-form-item>
				</el-form>
				<div class="form-tip">报价即锁价：提交后该行售出/调价不影响本单成交价；变现折扣=扣减折扣（提报多少扣多少），扣减单价=round(吊牌价×变现折扣)；上限为所选各行综合拿货折扣中的最低值。卖家应答后会按当前可用数量部分成交。</div>
				<div class="offer-total">预计扣减保证金 ¥{{ fenToYuan(offerQuoteTotal) }}</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeOffer">取消</el-button>
				<el-button type="primary" :loading="offerSaving" @click="onSaveOffer">提交报价</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { fenToYuan, apiMsg, formatCompositeDiscount, formatMarkupDiscount } from './money.js'

	export default {
		name: 'WarehouseGoods',
		data() {
			return {
				ready: false,
				warehouseId: '',
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				loading: false,
				selected: [],
				formfilter: {
					style_number: ''
				},
				markupShow: false,
				markupSaving: false,
				markupValue: '',
				defaultMarkup: '',
				defaultMarkupShow: false,
				defaultMarkupSaving: false,
				defaultMarkupValue: '',
				offerShow: false,
				offerSaving: false,
				offerItems: [],
				offerForm: {
					discount: '',
					remark: ''
				},
				ownImportShow: false,
				ownImportSaving: false,
				ownImportText: '',
				ownImportPath: '',
				ownAddShow: false,
				ownAddSaving: false,
				ownAddForm: {
					style_number: '',
					size: '',
					quantity: '',
					cost_discount: ''
				},
				costDiscountShow: false,
				costDiscountSaving: false,
				costDiscountValue: ''
			}
		},
		computed: {
			offerQuoteTotal() {
				var that = this
				return this.offerItems.reduce(function(sum, row) {
					var price = that.estQuote(row)
					return sum + (isNaN(price) ? 0 : price * Number(row.quantity || 0))
				}, 0)
			}
		},
		mounted() {
			this.loadWarehouse()
		},
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect()
			}
		},
		methods: {
			fenToYuan: fenToYuan,
			formatCompositeDiscount: formatCompositeDiscount,
			formatMarkupDiscount: formatMarkupDiscount,
			available(row) {
				return Math.max(0, Number(row.quantity || 0) - Number(row.sold_quantity || 0))
			},
			canOffer(row) {
				return this.available(row) > 0 && Number(row.seller_uid || 0) > 0
			},
			sourceText(row) {
				if (Number(row.seller_uid || 0) > 0) {
					return '卖家货'
				}
				if (Number(row.buyout_state || 0) === 1) {
					return '自有 · 已变现'
				}
				return '自有'
			},
			isOwned(row) {
				if (!row) {
					return false
				}
				if (Number(row.is_owned) === 1) {
					return true
				}
				if (row.is_owned === 0 || row.is_owned === '0') {
					return false
				}
				if (Number(row.buyout_state || 0) === 1) {
					return true
				}
				return row.seller_uid != null && row.seller_uid !== '' && Number(row.seller_uid) === 0
			},
			ownedDiscountText(row) {
				if (Number(row.buyout_state) === 1) {
					return '买断 ' + this.formatCompositeDiscount(row.cost_discount)
				}
				if (Number(row.cost_discount || 0) > 0) {
					return '成本 ' + this.formatCompositeDiscount(row.cost_discount)
				}
				return '—'
			},
			parseCostDiscount(val) {
				if (val === '' || val == null) {
					return NaN
				}
				var num = parseFloat(val)
				if (isNaN(num) || num <= 0 || num > 10) {
					return NaN
				}
				return num
			},
			skipOfferReason(rows) {
				var ownCount = 0
				var emptyCount = 0
				;(rows || []).forEach((row) => {
					if (this.canOffer(row)) {
						return
					}
					if (Number(row.seller_uid || 0) <= 0) {
						ownCount++
					} else {
						emptyCount++
					}
				})
				var parts = []
				if (ownCount) {
					parts.push(ownCount + ' 行自有货')
				}
				if (emptyCount) {
					parts.push(emptyCount + ' 行无可用量')
				}
				return {
					ownCount: ownCount,
					emptyCount: emptyCount,
					text: parts.join('、')
				}
			},
			fillOffer(rows) {
				this.offerItems = (rows || []).map(function(row) {
					var avail = Math.max(0, Number(row.quantity || 0) - Number(row.sold_quantity || 0))
					return {
						stock_id: row.id,
						style_number: row.style_number,
						size: row.size,
						available: avail,
						quantity: avail,
						retail_price: row.retail_price,
						composite_cost: row.composite_cost,
						unit_cost: row.unit_cost,
						discount: row.discount,
						composite_discount: row.composite_discount
					}
				}).filter(function(item) {
					return item.available > 0
				})
				if (!this.offerItems.length) {
					this.$message.warning('所选库存暂无可报数量')
					return
				}
				// 预填所选行最低供货折扣（天然 ≤ 综合拿货折扣上限，可上调到上限或再下调）
				var minDisc = Math.min.apply(null, this.offerItems.map(function(item) {
					return Number(item.discount || 0)
				}))
				this.offerForm = {
					discount: minDisc > 0 ? String(minDisc / 100) : '',
					remark: ''
				}
				this.offerShow = true
			},
			discountMilli() {
				var num = parseFloat(this.offerForm.discount)
				return isNaN(num) ? NaN : Math.round(num * 100)
			},
			estQuote(row) {
				// 8.1 提报口径：扣减单价 = round(吊牌价×变现折扣)，提报多少扣多少
				var discc = this.discountMilli()
				if (isNaN(discc)) {
					return NaN
				}
				return Math.round(Number(row.retail_price || 0) * discc / 1000)
			},
			estStr(fen) {
				return isNaN(fen) ? '--' : '¥' + this.fenToYuan(fen)
			},
			goIndex() {
				this.$router.push('/buyer/warehouse/index')
			},
			goBuyout() {
				this.$router.push('/buyer/warehouse/buyout')
			},
			bindFilterResize() {
				if (typeof ResizeObserver === 'undefined' || !this.$refs.filter) {
					return
				}
				if (this.resizeObserver) {
					this.resizeObserver.disconnect()
				}
				this.resizeObserver = new ResizeObserver(entries => {
					for (let entry of entries) {
						const cr = entry.contentRect
						if (this.$refs.tablediv) {
							this.$refs.tablediv.style.height = 'calc(100% - ' + (Number(cr.height) + 30) + 'px)'
						}
					}
				})
				this.resizeObserver.observe(this.$refs.filter)
			},
			loadWarehouse() {
				this.$axios.get('api/cloud_warehouse/info').then(res => {
					this.ready = true
					if (res.data.code === 0) {
						var info = res.data.data || {}
						this.warehouseId = info.id || ''
						this.defaultMarkup = info.markup_discount != null ? info.markup_discount : ''
						if (this.warehouseId) {
							this.onlist()
							this.$nextTick(() => {
								this.bindFilterResize()
							})
						}
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.ready = true
					console.log(err)
				})
			},
			onlist() {
				if (!this.warehouseId) {
					return
				}
				this.loading = true
				var params = {
					warehouse_id: this.warehouseId,
					page: this.page,
					limit: this.pageSize
				}
				if (this.formfilter.style_number) {
					params.style_number = this.formfilter.style_number
				}
				this.$axios.get('api/cloud_warehouse/stock_list', { params: params }).then(res => {
					this.loading = false
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.list = data.list || []
						this.total = data.count || 0
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.loading = false
					console.log(err)
				})
			},
			onfilter() {
				this.page = 1
				this.onlist()
			},
			onreset() {
				this.formfilter.style_number = ''
				this.page = 1
				this.onlist()
			},
			handleCurrentChange() {
				this.onlist()
			},
			handleSizeChange(val) {
				this.page = 1
				this.pageSize = val
				this.onlist()
			},
			onSelect(rows) {
				this.selected = rows || []
			},
			openMarkup() {
				if (!this.selected.length) {
					this.$message.warning('请先勾选商品')
					return
				}
				var first = this.selected[0]
				var cur = Number(first.markup_discount_custom || 0) > 0
					? Number(first.markup_discount_custom) / 100
					: Number(first.markup_discount || 0) / 100
				this.markupValue = String(cur)
				this.markupShow = true
			},
			closeMarkup() {
				this.markupShow = false
			},
			openOwnImport() {
				this.ownImportText = ''
				this.ownImportPath = ''
				this.ownImportShow = true
			},
			closeOwnImport() {
				this.ownImportShow = false
				this.ownImportText = ''
				this.ownImportPath = ''
			},
			onOwnImportUrl(url, res, file) {
				this.ownImportText = file && file.name ? file.name : ''
				this.ownImportPath = (res && (res.file || res.src)) || url || ''
			},
			ondownload() {
				window.open('https://oss.zhidayd.com/%E7%9B%B4%E8%BE%BE%E8%BF%90%E5%8A%A8-%E8%87%AA%E6%9C%89%E8%B4%A7%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xls', '_blank')
			},
			onSaveOwnImport() {
				if (!this.ownImportPath) {
					this.$message.error('请先上传模版')
					return
				}
				this.ownImportSaving = true
				this.$axios.post('api/cloud_warehouse/own_stock_import', {
					warehouse_id: this.warehouseId,
					path: this.ownImportPath
				}).then(res => {
					this.ownImportSaving = false
					if (res.data.code === 0) {
						this.$message.success('导入成功，请前往任务中心-导入列表查看结果')
						if (this.$parent && this.$parent.oncount) {
							this.$parent.oncount()
						}
						this.closeOwnImport()
						this.onlist()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.ownImportSaving = false
					console.log(err)
				})
			},
			openOwnAdd() {
				this.ownAddForm = {
					style_number: '',
					size: '',
					quantity: '',
					cost_discount: ''
				}
				this.ownAddShow = true
			},
			closeOwnAdd() {
				this.ownAddShow = false
			},
			onSaveOwnAdd() {
				var styleNumber = String(this.ownAddForm.style_number || '').trim()
				if (!styleNumber) {
					this.$message.warning('请输入款号')
					return
				}
				var size = String(this.ownAddForm.size || '').trim().toUpperCase()
				if (!size) {
					this.$message.warning('请输入尺码')
					return
				}
				var qty = parseInt(this.ownAddForm.quantity, 10)
				if (!qty || qty < 1 || qty > 100000) {
					this.$message.warning('数量须为 1-100000 的正整数')
					return
				}
				var discount = this.parseCostDiscount(this.ownAddForm.cost_discount)
				if (isNaN(discount)) {
					this.$message.warning('成本折扣范围为0-10（如4.35表示4.35折）')
					return
				}
				this.ownAddSaving = true
				this.$axios.post('api/cloud_warehouse/own_stock_add', {
					warehouse_id: this.warehouseId,
					style_number: styleNumber,
					size: size,
					quantity: qty,
					cost_discount: discount
				}).then(res => {
					this.ownAddSaving = false
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.$message.success(Number(data.merged) === 1 ? '已累加至对应库存行' : '已新增库存行')
						this.closeOwnAdd()
						this.onlist()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.ownAddSaving = false
					console.log(err)
				})
			},
			openCostDiscount() {
				if (!this.selected.length) {
					this.$message.warning('请先勾选商品')
					return
				}
				if (this.selected.length > 500) {
					this.$message.warning('单次最多设置500个商品')
					return
				}
				this.costDiscountValue = ''
				this.costDiscountShow = true
			},
			closeCostDiscount() {
				this.costDiscountShow = false
			},
			onSaveCostDiscount() {
				if (!this.selected.length) {
					this.$message.warning('请选择要设置的商品')
					return
				}
				if (this.selected.length > 500) {
					this.$message.warning('单次最多设置500个商品')
					return
				}
				var discount = this.parseCostDiscount(this.costDiscountValue)
				if (isNaN(discount)) {
					this.$message.warning('成本折扣范围为0-10（如4.35表示4.35折）')
					return
				}
				this.costDiscountSaving = true
				this.$axios.post('api/cloud_warehouse/set_cost_discount', {
					warehouse_id: this.warehouseId,
					stock_ids: JSON.stringify(this.selected.map(function(row) {
						return row.id
					})),
					cost_discount: discount
				}).then(res => {
					this.costDiscountSaving = false
					if (res.data.code === 0) {
						var data = res.data.data || {}
						var updated = Number(data.updated || 0)
						var skipped = Number(data.skipped || 0)
						this.$message.success('已更新 ' + updated + ' 行（跳过 ' + skipped + ' 行）')
						this.closeCostDiscount()
						this.onlist()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.costDiscountSaving = false
					console.log(err)
				})
			},
			onSaveMarkup() {
				if (!this.selected.length) {
					return
				}
				var num = parseFloat(this.markupValue)
				if (this.markupValue === '' || isNaN(num) || num < 0 || num > 10) {
					this.$message.warning('请输入 0~10 的加价折扣（如 2 表示加 2 折）')
					return
				}
				this.markupSaving = true
				this.$axios.post('api/cloud_warehouse/batch_set_markup', {
					warehouse_id: this.warehouseId,
					stock_ids: JSON.stringify(this.selected.map(function(row) {
						return row.id
					})),
					markup_discount: num
				}).then(res => {
					this.markupSaving = false
					if (res.data.code === 0) {
						var updated = (res.data.data && res.data.data.updated) || 0
						this.$message.success('已设置 ' + updated + ' 个商品的加价折扣')
						this.markupShow = false
						this.onlist()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.markupSaving = false
					console.log(err)
				})
			},
			openDefaultMarkup() {
				this.defaultMarkupValue = this.defaultMarkup !== '' ? String(this.defaultMarkup) : '2'
				this.defaultMarkupShow = true
			},
			closeDefaultMarkup() {
				this.defaultMarkupShow = false
			},
			onSaveDefaultMarkup() {
				var num = parseFloat(this.defaultMarkupValue)
				if (this.defaultMarkupValue === '' || isNaN(num) || num < 0 || num > 10) {
					this.$message.warning('请输入 0~10 的加价折扣（如 2 表示加 2 折）')
					return
				}
				this.defaultMarkupSaving = true
				this.$axios.post('api/cloud_warehouse/set_markup', {
					warehouse_id: this.warehouseId,
					markup_discount: num
				}).then(res => {
					this.defaultMarkupSaving = false
					if (res.data.code === 0) {
						this.$message.success('已更新默认加价折扣')
						this.defaultMarkup = String(num)
						this.defaultMarkupShow = false
						this.onlist()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.defaultMarkupSaving = false
					console.log(err)
				})
			},
			openOffer() {
				if (!this.selected.length) {
					this.$message.warning('请先勾选要报价的库存')
					return
				}
				var offerRows = this.selected.filter((row) => {
					return this.canOffer(row)
				})
				var skip = this.skipOfferReason(this.selected)
				if (!offerRows.length) {
					this.$message.warning('所选没有可报价的卖家在仓货' + (skip.text ? '（' + skip.text + '）' : ''))
					return
				}
				if (offerRows.length > 50) {
					this.$message.warning('单次最多提交50条明细')
					return
				}
				var sellerUid = Number(offerRows[0].seller_uid || 0)
				var mixed = offerRows.some(function(row) {
					return Number(row.seller_uid || 0) !== sellerUid
				})
				if (mixed) {
					this.$message.warning('报价明细需属于同一卖家，请分批勾选')
					return
				}
				if (skip.ownCount || skip.emptyCount) {
					this.$confirm('已排除 ' + skip.text + '，将对 ' + offerRows.length + ' 行卖家货发起报价，是否继续？', '确认发起变现报价', {
						confirmButtonText: '继续报价',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.fillOffer(offerRows)
					}).catch(() => {})
					return
				}
				this.fillOffer(offerRows)
			},
			closeOffer() {
				this.offerShow = false
				this.offerItems = []
			},
			onSaveOffer() {
				var num = parseFloat(this.offerForm.discount)
				if (this.offerForm.discount === '' || isNaN(num)) {
					this.$message.warning('请输入变现折扣（折数形态，如 4.5 表示 4.5 折）')
					return
				}
				if (num <= 0 || num > 10) {
					this.$message.warning('变现折扣范围为0-10（如4.5表示4.5折）')
					return
				}
				if (Math.abs(num * 10 - Math.round(num * 10)) > 1e-9) {
					this.$message.warning('变现折扣需为0.1折的整数倍（如4.5）')
					return
				}
				var minDisc = Math.min.apply(null, this.offerItems.map(function(item) {
					return Number(item.composite_discount || 0)
				}))
				if (num > minDisc / 100 + 1e-9) {
					this.$message.warning('变现折扣不能高于综合拿货折扣（上限：' + this.formatCompositeDiscount(minDisc) + '）')
					return
				}
				for (var f = 0; f < this.offerItems.length; f++) {
					var feeRow = this.offerItems[f]
					var feeUnit = Number(feeRow.composite_cost || 0) - Number(feeRow.unit_cost || 0)
					if (this.estQuote(feeRow) <= feeUnit) {
						var minOk = 0
						for (var scan = 10; scan <= 1000; scan += 10) {
							if (Math.round(Number(feeRow.retail_price || 0) * scan / 1000) > feeUnit) {
								minOk = scan
								break
							}
						}
						this.$message.warning('变现折扣过低（款号：' + feeRow.style_number + '，尺码：' + feeRow.size + '，最低：' + this.formatCompositeDiscount(minOk) + '）')
						return
					}
				}
				if (this.offerForm.remark && this.offerForm.remark.length > 255) {
					this.$message.warning('备注不能超过255位')
					return
				}
				var items = []
				for (var i = 0; i < this.offerItems.length; i++) {
					var row = this.offerItems[i]
					var qty = Number(row.quantity || 0)
					if (qty <= 0) {
						this.$message.warning('报价数量必须大于0')
						return
					}
					if (qty > row.available) {
						this.$message.warning('在仓不足（款号：' + row.style_number + '，尺码：' + row.size + '，可报：' + row.available + '）')
						return
					}
					items.push({
						stock_id: row.stock_id,
						quantity: qty
					})
				}
				var tip = '报价即锁价：提交后按本单快照成交（成交时扣减保证金 ¥' + this.fenToYuan(this.offerQuoteTotal) + '）。卖家应答前可能部分售出，将按当前可用数量部分成交；全部售罄自动失效（不扣资金）。'
				this.$confirm(tip, '确认提交变现报价？', {
					confirmButtonText: '确认提交',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.offerSaving = true
					this.$axios.post('api/cloud_warehouse/buyout_offer', {
						warehouse_id: this.warehouseId,
						items: JSON.stringify(items),
						offer_discount: num,
						remark: this.offerForm.remark || ''
					}).then(res => {
						this.offerSaving = false
						if (res.data.code === 0) {
							var data = res.data.data || {}
							this.$message.success('报价已提交（报价单 ID：' + data.id + '），等待卖家应答')
							this.closeOffer()
							this.$router.push('/buyer/warehouse/buyout')
						} else {
							this.$message.error(apiMsg(res))
						}
					}).catch(err => {
						this.offerSaving = false
						console.log(err)
					})
				}).catch(() => {})
			}
		}
	}
</script>

<style scoped lang="less">
	.warehouse-goods {
		height: 100%;
	}

	.empty-guide {
		padding: 80px 20px;
		text-align: center;
		.empty-title {
			font-size: 20px;
			font-weight: 600;
			margin-bottom: 12px;
		}
		.empty-desc {
			color: #909399;
			margin-bottom: 24px;
		}
	}

	.tablebox {
		height: calc(100% - 72px);
	}

	.tip {
		color: #909399;
		font-size: 12px;
		line-height: 20px;
	}

	.def-markup {
		margin-right: 4px;
		b {
			color: #F65730;
		}
	}

	.ok-text {
		color: #67C23A;
		margin-right: 4px;
	}

	.gray-text {
		color: #909399;
	}

	.offer-form {
		margin-top: 12px;
	}

	.form-tip {
		color: #909399;
		font-size: 12px;
		line-height: 20px;
		margin-top: 10px;
	}

	.offer-total {
		margin-top: 8px;
		font-weight: 600;
	}

	/deep/ .el-input-number {
		width: 72px;
	}

	/deep/ .el-input-number .el-input__inner {
		padding: 0 4px;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/warehouse/goods.vue